import i18next from "i18next";
import { getSkillName } from "../../../features/Assistants/helpers/getSkillName";
import { AssistantValue } from "../../../services/api/instances/assistantsApi/types";
import {
  isCallAssistantFunction,
  isCallAssistantSkillFunction,
  isCallKnowledgeBaseFunction,
  isFunctionCall,
  isMessage,
  isMessageInput,
} from "../../../services/api/instances/responseApi/typeGuards";
import {
  FunctionToolCallType,
  InputItemList,
  TAssistantPluginCallArgs,
} from "../../../services/api/instances/responseApi/types/common";
import { StorageObject } from "../../../services/api/instances/storageApi/types/object_types";

export const findAssistantByRef = (
  nodes: StorageObject<AssistantValue>[],
  targetRef: string,
): StorageObject<AssistantValue> | null => {
  for (const node of nodes) {
    if (node.ref === targetRef) {
      return node;
    }
    if (node.value === null && node.children && node.children.length > 0) {
      const foundInChildren = findAssistantByRef(node.children, targetRef);
      if (foundInChildren) {
        return foundInChildren;
      }
    }
  }

  return null;
};

const getCalledAssistantName = (
  functionObject: FunctionToolCallType,
  assistants: StorageObject<AssistantValue>[],
): string | null => {
  if (isCallAssistantFunction(functionObject)) {
    const args: TAssistantPluginCallArgs = JSON.parse(functionObject.arguments);
    const ref = args.assistant_ref;
    const calledAssistant = findAssistantByRef(assistants, ref);
    if (!calledAssistant) return null;
    return calledAssistant?.friendly_name;
  }
  return null;
};

export const getChatLogs = (
  input: InputItemList,
  assistants: StorageObject<AssistantValue>[],
) => {
  const item = input[0];
  if (isMessageInput(item)) {
    return `${i18next.t("agents.request_log")}`;
  } else if (isFunctionCall(item)) {
    if (isCallKnowledgeBaseFunction(item)) {
      return `${i18next.t("agents.knowledge_base_log")}`;
    }
    if (isCallAssistantSkillFunction(item)) {
      const args = JSON.parse(item.arguments);
      const skillName = getSkillName(args.skill_name);
      return `${i18next.t("agents.skill_log")} "${skillName}"`;
    }
    const name = getCalledAssistantName(item, assistants);
    return name
      ? `${i18next.t("agents.assistant_log")} ${name}...`
      : `${i18next.t("agents.function_log")} ${item.name}...`;
  } else if (typeof item === "string" || item.type === "function_call_output") {
    return `${i18next.t("agents.response_log")}`;
  }
  return "";
};
